var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeat6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 62,
    viewBox: "0 0 82 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 31C72 13.8792 58.1208 0 41 0C23.8792 0 10 13.8792 10 31C10 48.1208 23.8792 62 41 62C58.1208 62 72 48.1208 72 31Z",
    fill: "url(#paint0_linear_5_88)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.383 45.4658H45.4775L46.8552 52.0103H35.833L37.383 45.4658Z",
    fill: "#A8A9AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.957 43.5945C18.9563 44.2024 19.0515 44.8044 19.2372 45.3662C19.423 45.928 19.6956 46.4384 20.0394 46.8682C20.3833 47.298 20.7916 47.6388 21.241 47.8709C21.6904 48.1031 22.1721 48.2221 22.6584 48.2212H59.6871C60.6688 48.2206 61.6101 47.733 62.3045 46.8655C62.9988 45.9981 63.3894 44.8216 63.3904 43.5945V41.6768H18.957V43.5945Z",
    fill: "#A8A9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7218 17.1582H23.6187C21.6813 17.1582 20.1084 18.6637 20.1084 20.5211V42.6633H62.2321V20.5211C62.2398 18.6637 60.6688 17.1582 58.7218 17.1582Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9248 52.6992H33.4248",
    stroke: "url(#paint1_linear_5_88)",
    strokeWidth: 1.86281,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.957 42.5623C18.9563 43.1702 19.0515 43.7722 19.2372 44.334C19.423 44.8957 19.6956 45.4062 20.0394 45.836C20.3833 46.2658 20.7916 46.6065 21.241 46.8387C21.6904 47.0709 22.1721 47.1899 22.6584 47.189H59.6871C60.6688 47.1883 61.6101 46.7008 62.3045 45.8333C62.9988 44.9658 63.3894 43.7894 63.3904 42.5623V40.6445H18.957V42.5623Z",
    fill: "url(#paint2_linear_5_88)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6977 12.8037H22.6611C21.6787 12.8037 20.7366 13.1929 20.0419 13.8856C19.3473 14.5784 18.957 15.5179 18.957 16.4976V40.8128H63.4018V16.4976C63.4013 15.5181 63.0109 14.5788 62.3163 13.8862C61.6218 13.1936 60.68 12.8042 59.6977 12.8037Z",
    fill: "url(#paint3_linear_5_88)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5171 44.7763C42.1829 44.7763 42.7226 44.2366 42.7226 43.5708C42.7226 42.905 42.1829 42.3652 41.5171 42.3652C40.8513 42.3652 40.3115 42.905 40.3115 43.5708C40.3115 44.2366 40.8513 44.7763 41.5171 44.7763Z",
    fill: "#6D6F75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5171 44.7763C42.1829 44.7763 42.7226 44.2366 42.7226 43.5708C42.7226 42.905 42.1829 42.3652 41.5171 42.3652C40.8513 42.3652 40.3115 42.905 40.3115 43.5708C40.3115 44.2366 40.8513 44.7763 41.5171 44.7763Z",
    fill: "url(#paint4_linear_5_88)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8253 14.1221H23.5198C21.5713 14.1221 19.9893 15.6876 19.9893 17.6191V40.6443H62.3559V17.6191C62.3636 15.6876 60.7835 14.1221 58.8253 14.1221Z",
    fill: "url(#paint5_linear_5_88)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5353 18.5859H26V36.6368H55.5353V18.5859Z",
    fill: "url(#paint6_linear_5_88)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8175 29.8349L26 18.5859H55.5353L40.8175 29.8349Z",
    fill: "#12571C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 5C53.7074 5 49 9.70745 49 15.5C49 21.2926 53.7074 26 59.5 26C65.2926 26 70 21.2926 70 15.5C70 9.70745 65.2926 5 59.5 5Z",
    fill: "#3A7343"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0841 13.3077C54.5061 12.7581 55.1493 12.3906 55.9753 12.3906C57.5792 12.3906 58.7175 13.3869 59.6443 14.3549C60.0313 13.9445 60.4428 13.5331 60.8872 13.1998C61.5057 12.7357 62.228 12.3906 63.1014 12.3906C63.9754 12.3906 64.6682 12.7388 65.1341 13.2852C65.5897 13.8195 65.8034 14.5122 65.8034 15.1833C65.8034 15.8544 65.5897 16.547 65.1341 17.0813C64.6682 17.6277 63.9754 17.9759 63.1014 17.9759C62.2284 17.9759 61.5063 17.6308 60.8878 17.1667C60.4433 16.8332 60.0316 16.4216 59.6444 16.011C58.7177 16.9792 57.5796 17.9759 55.9753 17.9759C55.1493 17.9759 54.5061 17.6085 54.0841 17.0588C53.6741 16.5246 53.4863 15.8401 53.4863 15.1833C53.4863 14.5264 53.6741 13.8419 54.0841 13.3077ZM58.8699 15.183C57.953 14.2253 57.1116 13.5214 55.9753 13.5214C55.5188 13.5214 55.2003 13.7108 54.9811 13.9963C54.7499 14.2974 54.6171 14.7265 54.6171 15.1833C54.6171 15.64 54.7499 16.0691 54.9811 16.3702C55.2003 16.6558 55.5188 16.8451 55.9753 16.8451C57.1118 16.8451 57.9529 16.141 58.8699 15.183ZM60.4181 15.1829C60.8078 15.5979 61.1762 15.9695 61.5664 16.2623C62.0612 16.6335 62.55 16.8451 63.1014 16.8451C63.6518 16.8451 64.0274 16.6365 64.2737 16.3477C64.5303 16.0467 64.6727 15.6258 64.6727 15.1833C64.6727 14.7407 64.5303 14.3198 64.2737 14.0189C64.0274 13.73 63.6518 13.5214 63.1014 13.5214C62.5496 13.5214 62.0605 13.7331 61.5657 14.1043C61.1757 14.3969 60.8075 14.7682 60.4181 15.1829Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_88",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_88",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_88",
    x1: 18.957,
    y1: 43.9168,
    x2: 63.3904,
    y2: 43.9168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_88",
    x1: 18.957,
    y1: 26.8083,
    x2: 63.4018,
    y2: 26.8083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_88",
    x1: 39.7757,
    y1: 43.4368,
    x2: 43.1245,
    y2: 43.4368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_88",
    x1: 19.9893,
    y1: 27.3832,
    x2: 62.3559,
    y2: 27.3832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BC60",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#55BC60",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_88",
    x1: 26,
    y1: 18.4998,
    x2: 59.5,
    y2: 38.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat6);
export default __webpack_public_path__ + "static/media/feat-6.4faeaf588ce7dd72a3819aa0c41a64c4.svg";
export { ForwardRef as ReactComponent };